import React, { memo, useRef, useEffect } from 'react';
import { useDrag, useDrop } from 'react-dnd';

const DragWrapperTab = memo(({ id, children, moveTab, findTab }) => {
    const originalIndex = findTab(id).index;
    const ref = useRef(null);

    const [, drag] = useDrag(
        () => ({
            type: 'TAB',
            item: { id, originalIndex },
            collect: (monitor) => ({
                isDragging: monitor.isDragging(),
            }),
            end: (item, monitor) => {
                const { id: droppedId, originalIndex } = item;
                const didDrop = monitor.didDrop();
                if (!didDrop) {
                    moveTab(droppedId, originalIndex);
                }
            },
        }),
        [id, originalIndex, moveTab],
    );

    const [, drop] = useDrop(
        () => ({
            accept: 'TAB',
            hover(item, monitor) {
                if (!ref.current) {
                    return;
                }
                const dragIndex = findTab(item.id).index;
                const hoverIndex = findTab(id).index;

                if (dragIndex === hoverIndex) {
                    return;
                }

                const hoverBoundingRect = ref.current.getBoundingClientRect();
                const hoverWidth = hoverBoundingRect.right - hoverBoundingRect.left;
                const threshold = hoverWidth * 0.8;
                const clientOffset = monitor.getClientOffset();
                const hoverClientX = clientOffset.x - hoverBoundingRect.left;

                if (dragIndex > hoverIndex && hoverClientX > threshold) {
                    return;
                }

                if (dragIndex < hoverIndex && hoverClientX < hoverWidth - threshold) {
                    return;
                }

                moveTab(item.id, hoverIndex);
            },
        }),
        [findTab, moveTab, id],
    );

    useEffect(() => {
        drag(drop(ref));
    }, [drag, drop]);

    return (
        <div key={id} ref={ref}>
            {children}
        </div>
    );
});

export default DragWrapperTab;
